// extracted by mini-css-extract-plugin
export default {"item":"BetaSlider_item__YJt5Z","wrapper":"BetaSlider_wrapper__eyMS8","dots":"BetaSlider_dots__nHju6","dt_nav":"BetaSlider_dt_nav__EqBeE"};